// extracted by mini-css-extract-plugin
export default {"section":"styles_section__Fxtd1","error":"styles_error__-o4Ef","message":"styles_message__6AcK2","hide":"styles_hide__rrHZY"};